// extracted by mini-css-extract-plugin
module.exports = {"select":"FormSelect_select__FWd1T"};